<ion-content>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
  <ng-container>
    <div style=" padding-top: 15px; padding-left: 2%;"><b>Web Order Steps Admin</b></div>
    <ion-grid>
      <div class="product-table">

        <table class="custom-table">
          <thead>
           <tr>
              <th rowspan="2" style="width:8%">Steps</th>
              <th rowspan="2"  style="width:20%">Short Name</th>
              <th rowspan="2">Description</th>
            </tr>
          </thead>
          <tbody>
          <tr *ngFor="let wo of woOrderSteps">
              <ng-container >
                  <td>{{ wo.stepNumber }}</td>
                 <td><input type="text" [(ngModel)]="wo.sNameData" class="cell-input" /></td>
                <td><textarea  [(ngModel)]="wo.sDescData" class="cell-input" ></textarea></td>
              </ng-container>
          </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="woOrderSteps?.length === 0"  style="padding-left:40%;color:red" class="alert alert-info mt-3">
        No Data found.
      </div>


            
        </ion-grid>
         <div class="form-actions" style=" float: right;padding-right:2%;">
          <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="saveWebOrderTypeSteps()" ><span>Update</span></ion-button>
      </div>
    </ng-container>
</ion-content>
